import { request } from "@/lib/datocms";

export const fetchCMSDataQuery = (query, preview, variables = {}) =>
  request({ query: query, preview: preview, variables });

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  fetchCMSDataQuery,
};
